import {Component} from '@angular/core';
import {VerbrauchsanalyseStepComponent} from "./verbrauchsanalyse.step.component";
import {ModeratConstants} from "../moderat.constants";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ModeratRequestService} from "../services/request.service";
import {ElementService} from "../../services/element.service";
import {DecimalPipe} from "@angular/common";
import {PortalService} from "../../services/portal.service";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";

/**
 *
 */
@Component({
  selector: 'app-moderat-verbrauchsanalyse-ergebnis',
  templateUrl: './verbrauchsanalyse.ergebnis.component.html',
  providers: [DecimalPipe]
})
export class VerbrauchsanalyseErgebnisComponent extends VerbrauchsanalyseStepComponent {

  /**
   * indicator if a result is avaibalbe
   */
  hasResult: boolean = false;

  /**
   * the object of the result, from anfrge object
   */
  result: any;

  /**
   * some placeholders for the texts
   */
  placeholder: {};

  /**
   * The satge that we need for the texts
   */
  stage: number = null;

  /**
   * The users path on the advisor
   */
  path: string;

  /**
   * @inheritDoc
   *
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   * @param decimalPipe
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: ModeratRequestService, protected elementService: ElementService,
              protected portalService: PortalService, private decimalPipe: DecimalPipe, protected energyMapService: EnergyMapService) {
    super(stepService, router, requestService, elementService, portalService, energyMapService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // check if there is a result that we can show
    if(this.anfrage.verbrauchsanalyseResult.hasOwnProperty("status") && this.anfrage.verbrauchsanalyseResult.status.code === 0) {
      this.hasResult = true;
      this.result = this.anfrage.verbrauchsanalyseResult.data.durchschnitt;

      // calculation for tree replacements with fallback if the backend does not deliver a value
      let trees = this.result.co2_gesamt_ausgleich_baeume;
      if(!trees || trees < 0) {
        trees = this.result.co2_gesamt_tonnen_jahr * 1000 / ModeratConstants.CO2_TREE_KG_YEAR
      }

      // prepare some placeholder for the texts
      this.placeholder = {
        evkw: this.decimalPipe.transform(this.result.evkw * 1, '1.0-0'),
        co2:  this.decimalPipe.transform(this.result.co2_gesamt_tonnen_jahr * 1, '1.0-1'),
        trees: this.decimalPipe.transform(trees, '1.0-0'),
        lastyear: this.anfrage.verbrauchsanalyseResult.data.letzte.abrechnungsjahr
      }

      // set the path
      this.path = this.anfrage.getPath();
    }
    else {
      console.warn("no result to display");
    }
  }

  /**
   * Updates the stage value
   */
  setStage(stage: number) {
    this.stage = stage;
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // scroll to the top
    const element = document.querySelector("body");
    this.elementService.scrollToElement(element)
  }
}
